import { v4 as uuidv4 } from 'uuid';

import {
  createBorrowerShell,
  createCapitalProviderRepresentativeShell,
  createCapitalProviderShell,
  createCreditAgreementShell,
} from '@finley-technologies/credit-agreement-utils';

import {
  CreditAgreement,
  DbTable,
} from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

export const createCreditAgreementFullArtifactWipShell = ({
  creditFacilityId,
  facilityType,
}: {
  creditFacilityId: string;
  facilityType: DbTable.FacilityType;
}): CreditAgreement.DomainEntity.CreditAgreementFullArtifact => {
  const creditAgreement = createCreditAgreementShell({
    creditFacilityId,
    facilityType,
  });
  const parties = creditAgreement.facilityMechanics.parties;
  parties.borrowers.push(createBorrowerShell(uuidv4()));
  parties.capitalProviders.push(createCapitalProviderShell(uuidv4()));
  parties.capitalProviderRepresentatives.push(
    createCapitalProviderRepresentativeShell(uuidv4()),
  );
  return creditAgreement;
};
